import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';
import ExampleBackButton from '../example-buttons/ExampleBackButton.vue';

# Editing a Scene

## <v-icon>mdi-rename-box</v-icon> Scene Details

### Name

This is where you can edit the Scene name.

### Description

This is where you can edit the Scene description.

## <v-icon>mdi-tune</v-icon> Scene Variables

Note: These variables are created by the Template (Ventuz Scene Designer), this is simply where we control these variables in CanvasPro.

If no variables are changed, then the default variables in the Template will be used. (see the Template that created the Scene)

## <v-icon>mdi-motion-play-outline</v-icon> Scene Play Conditions

Note: Play Conditions may be set in the Template used to create this Scene. You can override them here, or if they're need on all Templates, it may be better to apply them there.

This is where you can add Play Conditions to the Scene.

## <v-icon>mdi-star-shooting</v-icon> Scene Domination Mode

This is where you can select the Domination Mode for this Scene.

Domination forces this Scene live when it's play conditions are valid.

- Disabled (doesn't automatically go live)
- Interrupt (plays straight away)
- Play Next (plays after the currently playing Scene finishes)

## <v-icon>mdi-share-all</v-icon> Scene Triggers

**Note:** Triggers are a new feature, and are currently limited to what Triggers are available.

Triggers allow you to do various actions when this Scene plays.

This can be used for triggering all Frames to display the same Scene when a Trigger has been met.

## Saving

To save the changes to this Scene click <ExampleSaveButton /> (bottom right).

## Cancelling Changes

Click <ExampleCloseButton /> (top right).

## Deleting

To delete this Scene, click <ExampleDeleteButton /> (bottom left). A confirmation box will appear.

Click <ExampleDeleteButton /> to delete or <ExampleBackButton /> to cancel.
